import { CardSearchIcon } from './CardSearchIcon';

/**
 * author: Google
 * id 2A09F869-B221-4ABC-B803-16560B7BA900
 * name card-search
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/card-search.svg
 * tags
 */
export const PageviewIcon = CardSearchIcon;
export default PageviewIcon